import authClient from '@/plugins/axios/authClient'
import authV2Client from '@/plugins/axios/authV2Client'

export default {
  /**
   * 이메일 중복 확인
   * @param {*} email 이메일
   * @returns
   */
  emailDuplicate(email) {
    return authClient.get(`/auth/duplicated-email?email=${email}`)
  },
  /**
   * 휴대폰 중복 확인
   * @param {*} phone 휴대폰번호
   * @returns
   */
  phoneDuplicate(phone) {},
  /**
   * 인증문자 발송
   * @param {*} phone 휴대폰번호
   * @returns
   */
  getVerificationCode(phone) {
    return authClient.post('/auth/phone/verify', {
      phone,
    })
  },
  /**
   * 인증문자 확인
   * @param {*} phone 휴대폰번호
   * @param {*} verificationCode 인증번호
   * @param {*} expirationTime 인증번호 받을때 준거
   * @param {*} token 인증번호 받을때 준거
   * @returns
   */
  confirmVerificationCode({ phone, verificationCode, expirationTime, token }) {
    return authClient.post('/auth/phone/verify/confirm', {
      phone,
      verificationCode,
      expirationTime,
      token,
    })
  },
  /**
   * 회원가입
   * @param {*} username 이메일
   * @param {*} password 패스워드
   * @param {*} password2 패스워드 확인
   * @param {*} phone 휴대폰 번호
   * @param {*} operationStatus 회원 상태
   * @param {*} agreementList 약관 동의 리스트
   * @param {*} referralCode 추천인 코드
   * @returns
   */
  signup({
    email,
    password1,
    password2,
    phone,
    operationStatus,
    agreementList,
    verification,
    utm,
    referralCode,
  }) {
    // v2로 호출
    return authV2Client.post('/auth/registration', {
      email,
      password1,
      password2,
      phone,
      operationStatus,
      agreementList,
      verification,
      utm,
      referralCode,
    })
  },
  // signupWithMall({ email, password1, password2, agreementList, utm, mall }) {
  //   return authClient.post('/auth/registration-with-mall', {
  //     email,
  //     password1,
  //     password2,
  //     agreementList,
  //     utm,
  //     mall,
  //   })
  // },
  affiliatesRegistration(data) {
    return authClient.post('/affiliates/user-registration', data)
  },
  postTempSignup(data) {
    return authClient.post('/tracking/free', data)
  },
}
